import { useState, useEffect } from 'react';
import { AbsenceSettings } from '../../../types/instanceTypes';
import { getAbsenceSettings, updateAbsenceSettings } from '../../../services/instanceService';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

export const useAbsenceSettings = () => {
  const { t } = useTranslation();
  const [absenceSettings, setAbsenceSettings] = useState<AbsenceSettings>({
    threshold: 0,
    alertLevels: {
      warning: 0,
      critical: 0
    }
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);



  const fetchAbsenceSettings = async () => {
    try {
      setLoading(true);
      const settings = await getAbsenceSettings();
      setAbsenceSettings(settings);
      setError(null);
    } catch (err) {
      setError('Failed to fetch absence settings');
      console.error('Error fetching absence settings:', err);
      message.error(t("failed_to_fetch_absence_settings"));
    } finally {
      setLoading(false);
    }
  };

  const saveAbsenceSettings = async (settings: {absenceConfig: AbsenceSettings}) => {
    try {
      setLoading(true);
      const updatedSettings = await updateAbsenceSettings(settings);
      setAbsenceSettings(updatedSettings);
      message.success(t("absence_settings_updated_successfully"));
      return true;
    } catch (err) {
      setError('Failed to update absence settings');
      console.error('Error updating absence settings:', err);
      message.error(t("failed_to_update_absence_settings"));
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    absenceSettings,
    setAbsenceSettings,
    loading,
    error,
    saveAbsenceSettings,
    fetchAbsenceSettings
  };
};
